(ns dashboard.subs
  (:require
   [clojure.string :refer [split]]
   [re-frame.core :as re-frame]
   [dashboard.subs.event-organizer :as event-organizer-subs]
   [dashboard.utils :refer
    [index-by index-of parse-values json-> isOff format-time distinct-by]]
   ["date-fns" :refer
    [getMonth startOfMonth endOfMonth eachDayOfInterval format isSameDay]]
   ["date-fns/locale" :as date-fns-locale]))

(re-frame/reg-sub
 ::loading?
 (fn [db _]
   (:loading? db)))

(re-frame/reg-sub
 ::in-page-loading?
 (fn [db _]
   (> (:loading-refcount db) 0)))

(re-frame/reg-sub
 ::is-demo?
 (fn [db _]
   (:is-demo? db)))

(re-frame/reg-sub
 ::time
 (fn [db _]
   (:time db)))

;; Routes

(re-frame/reg-sub
 ::current-route
 (fn [db _]
   (:current-route db)))

(re-frame/reg-sub
 ::current-route-name
 (fn [db _]
   (get-in (:current-route db) [:data :name])))

(re-frame/reg-sub
 ::current-route-title
 (fn [db _]
   (get-in (:current-route db) [:data :title])))

(re-frame/reg-sub
 ::current-route-subtitle
 (fn [db _]
   (get-in (:current-route db) [:data :subtitle])))

(re-frame/reg-sub
 ::current-route-query-params
 (fn [db _]
   (parse-values (get-in (:current-route db) [:query-params]))))

(re-frame/reg-sub
 ::current-route-path-params
 (fn [db _]
   (parse-values (get-in (:current-route db) [:parameters :path]))))

;; Userinfo

(re-frame/reg-sub
 ::userinfo
 (fn
   [db _]
   (-> (get-in db [:settings :userinfo])
       (assoc :spokenLanguages (into #{} (:spokenLanguages (get-in db [:settings :userinfo])))))))

(re-frame/reg-sub
 ::locale
 (fn [db _]
   (keyword (or (get-in db [:settings :userinfo :locale]) "ja"))))

(re-frame/reg-sub
 ::date-fns-locale
 :<- [::locale]
 (fn [locale]
   (cond
     (= locale :en) date-fns-locale/en
     (= locale :ja) date-fns-locale/ja
     (= locale :fr) date-fns-locale/fr
     :else date-fns-locale/en)))

;; Project config values

(re-frame/reg-sub
 ::logo
 (fn [db _]
   (:logo db)))

(re-frame/reg-sub
 ::logo-reversed
 (fn [db _]
   (:logo-reversed db)))

(re-frame/reg-sub
 ::company-name
 (fn [db _]
   (:company-name db)))

(re-frame/reg-sub
 ::product-name
 (fn [db _]
   (:product-name db)))

(re-frame/reg-sub
 ::colors
 (fn [db _]
   (:colors db)))

;; -------------------------
;; Notifications

(re-frame/reg-sub
 ::notification
 (fn [db]
   (get db :notification)))

;; -------------------------
;; User Guide

(re-frame/reg-sub
 ::user-guide
 (fn [db]
   (get db :user-guide)))

;; -------------------------
;; Sample Data

(re-frame/reg-sub
 ::organization
 (fn [db]
   (get-in db [:settings :organization])))

(re-frame/reg-sub
 ::items
 (fn [db]
   (get db :items)))

(re-frame/reg-sub
 ::items-count
 (fn [db]
   (count (get db :items))))

(re-frame/reg-sub
 ::calendars
 (fn [db]
   (get db :calendars)))

(re-frame/reg-sub
 ::calendars-by-id
 (fn [db]
   (index-by (get db :calendars) :id)))

(re-frame/reg-sub
 ::roles
 (fn [db]
   (get db :roles)))

(re-frame/reg-sub
 ::roles-by-id
 (fn [db]
   (index-by (get db :roles) :id)))

(re-frame/reg-sub
 ::titles
 (fn [db]
   (get db :titles)))

(re-frame/reg-sub
 ::titles-by-id
 (fn [db]
   (index-by (get db :titles) :id)))

(re-frame/reg-sub
 ::user-role
 :<- [::userinfo]
 :<- [::roles-by-id]
 (fn [[userinfo roles-by-id]]
   (get roles-by-id (:roleId userinfo))))

(re-frame/reg-sub
 ::user-resources
 :<- [::user-roles]
 (fn [user-role]
   (into #{} (map :resource (:permissions user-role)))))

(re-frame/reg-sub
 ::teams
 :<- [::selected-space-id]
 :<- [::spaces-by-id]
 (fn [[space-id spaces-by-id]]
   (:teams (get spaces-by-id space-id))))

(re-frame/reg-sub
 ::space-teams
 :<- [::selected-space-id]
 :<- [::spaces-by-id]
 (fn [[space-id spaces-by-id]]
   (:teams (get spaces-by-id space-id))))

(re-frame/reg-sub
 ::teams-by-name
 :<- [::space-teams]
 (fn [teams]
   (index-by teams :name)))

(re-frame/reg-sub
 ::teams-by-id
 :<- [::space-teams]
 (fn [teams]
   (index-by teams :id)))

(re-frame/reg-sub
 ::staffs
 (fn [db]
   (->> (get db :staffs)
        (into [])
        (remove #(= (second (split (:email %) "@")) "tachikoma-ai.com")))))

(re-frame/reg-sub
 ::staffs-count
 :<- [::staffs]
 (fn [staffs]
   (count staffs)))

(re-frame/reg-sub
 ::available-staffs
 :<- [::staffs]
 :<- [::userinfo]
 (fn [[staffs userinfo]]
   (if (some? (:spaceId userinfo))
     (->> staffs
          (filter #(= (:spaceId userinfo) (:spaceId %))))
     staffs)))

(re-frame/reg-sub
 ::available-staffs-count
 :<- [::available-staffs]
 (fn [staffs]
   (count staffs)))

(re-frame/reg-sub
 ::staffs-by-id
 (fn [db]
   (index-by (get db :staffs) :id)))

(re-frame/reg-sub
 ::staffs-by-team
 (fn [db]
   (group-by :teamId (get db :staffs))))

(re-frame/reg-sub
 ::spaces
 (fn [db]
   (get db :spaces)))

(re-frame/reg-sub
 ::spaces-by-id
 (fn [db]
   (index-by (get db :spaces) :id)))

(re-frame/reg-sub
 ::active-spaces
 (fn [db]
   (->> (get db :spaces)
        (filter #(true? (:isActive %))))))

(re-frame/reg-sub
 ::selected-space-id
 (fn [db]
   (get-in db [:selected :space-id])))

(re-frame/reg-sub
 ::selected-space
 :<- [::selected-space-id]
 :<- [::spaces-by-id]
 (fn [[space-id spaces-by-id]]
   (get spaces-by-id space-id)))

(re-frame/reg-sub
 ::timezone
 :<- [::selected-space]
 (fn [space]
   (:timezone space)))

(re-frame/reg-sub
 ::shift-patterns
 :<- [::selected-space-id]
 :<- [::spaces-by-id]
 (fn [[space-id spaces-by-id]]
   (->> (:shiftPatterns (get spaces-by-id space-id))
        (sort-by :isDayOff))))

(re-frame/reg-sub
 ::shift-patterns-by-symbol
 :<- [::shift-patterns]
 (fn [shift-patterns]
   (index-by shift-patterns :symbol)))

(re-frame/reg-sub
 ::shift-patterns-by-id
 :<- [::shift-patterns]
 (fn [shift-patterns]
   (index-by shift-patterns :id)))

(def keycodes
  {"0" 48
   "1" 49
   "2" 50
   "3" 51
   "4" 52
   "5" 53
   "6" 54
   "7" 55
   "8" 56
   "9" 57
   "A" 65
   "B" 66
   "C" 67
   "D" 68
   "E" 69
   "F" 70
   "G" 71
   "H" 72
   "I" 73
   "J" 74
   "K" 75
   "L" 76
   "M" 77
   "N" 78
   "O" 79
   "P" 80
   "Q" 81
   "R" 82
   "S" 83
   "T" 84
   "U" 85
   "V" 86
   "W" 87
   "X" 88
   "Y" 89
   "Z" 90
   "休" 89 ;; Yasumi -> Y
   "外" 71 ;; Gai -> G
   "出" 83 ;; Shutsu -> S
   })

(re-frame/reg-sub
 ::shift-patterns-keycodes
 :<- [::shift-patterns]
 (fn [shift-patterns]
   (->> shift-patterns
        (map :symbol)
        (remove #(nil? (get keycodes (first %))))
        (map #(map identity %))
        (mapv (fn [chars]
                (mapv #(hash-map :keyCode (get keycodes %)) chars))))))

(re-frame/reg-sub
 ::shift-tags
 :<- [::selected-space-id]
 :<- [::spaces-by-id]
 (fn [[space-id spaces-by-id]]
   (:shiftTags (get spaces-by-id space-id))))

(re-frame/reg-sub
 ::shift-tags-by-id
 :<- [::shift-tags]
 (fn [shift-tags]
   (index-by shift-tags :id)))

(re-frame/reg-sub
 ::shift-formulas
 :<- [::selected-space-id]
 :<- [::spaces-by-id]
 (fn [[space-id spaces-by-id]]
   (:shiftFormulas (get spaces-by-id space-id))))

(re-frame/reg-sub
 ::shift-formulas-by-id
 :<- [::shift-formulas]
 (fn [shift-formulas]
   (index-by shift-formulas :id)))

(re-frame/reg-sub
 ::work-days-by-month
 :<- [::selected-space-id]
 :<- [::spaces-by-id]
 (fn [[space-id spaces-by-id]]
   (-> (:workDaysByMonth (get spaces-by-id space-id))
       (json-> {:keywordize-keys false}))))

(re-frame/reg-sub
 ::space-staffs
 :<- [::selected-space-id]
 :<- [::staffs]
 (fn [[space-id staffs]]
   (->> staffs
        (filter #(= (:spaceId %) space-id)))))

(re-frame/reg-sub
 ::space-staffs-by-team
 :<- [::space-staffs]
 :<- [::teams-by-id]
 :<- [::space-teams]
 (fn [[staffs teams-by-id space-teams]]
   (let [team-order (->> space-teams
                         (map-indexed (fn [k v] {(:id v) k}))
                         (apply merge)
                         (merge {nil 1000}))]
     (->> (group-by :teamId staffs)
          (map (fn [[k v]]
                 (let [team (get teams-by-id k)
                       member-ids (or (:memberIds team) [])]
                   {k (sort-by #(or (index-of member-ids (:id %)) 1000) (into [] v))})))
          (into {})
          (sort-by #(get team-order (first %)))))))

(re-frame/reg-sub
 ::space-staffs-by-title
 :<- [::space-staffs]
 (fn [staffs]
   (->> (group-by :titleId staffs)
        (sort-by first)
        (reverse))))

(re-frame/reg-sub
 ::space-shifts
 (fn [db]
   (get db :space/shifts)))

(re-frame/reg-sub
 ::shifts
 :<- [::space-shifts]
 :<- [::selected-space-id]
 (fn [[space-shifts selected-space-id]]
   (->> (or (get space-shifts selected-space-id) [])
        (map #(assoc % :date (format (js/Date. (:start %)) "yyyy-MM-dd"))))))

(re-frame/reg-sub
 ::shifts-by-staff
 :<- [::shifts]
 (fn [shifts]
   (group-by :userId shifts)))

(re-frame/reg-sub
 ::my-shifts
 :<- [::shifts-by-staff]
 :<- [::userinfo]
 (fn [[shifts-by-staff userinfo]]
   (get shifts-by-staff (:id userinfo))))

(re-frame/reg-sub
 ::shifts-by-staff-and-date
 :<- [::shifts-by-staff]
 (fn [shifts]
   (->> shifts
        (map (fn [[k v]]
               (hash-map k (index-by v :date))))
        (merge)
        (into {}))))

(re-frame/reg-sub
 ::shift-hours-by-staff
 :<- [::shifts-by-staff-and-date]
 :<- [::shift-patterns-by-id]
 (fn [[shifts patterns-by-symbol] [_ month]]
   (->> shifts
        (map (fn [[staff-id staff-shifts]]
               {staff-id (->> (vals staff-shifts)
                              (filter #(= (getMonth (js/Date. (:date %))) (getMonth month)))
                              (map :patternId)
                              (map #(:hours (get patterns-by-symbol %)))
                              (reduce +))}))
        (into {}))))

(re-frame/reg-sub
 ::default-month-work-days
 (fn [_ [_ month]]
   (let [month (or month (js/Date.))]
     (->> (eachDayOfInterval
           #js {:start (startOfMonth month)
                :end (endOfMonth month)})
          (remove #(isOff %))
          (count)))))

(re-frame/reg-sub
 ::default-month-off-days
 (fn [_ [_ month]]
   (let [month (or month (js/Date.))]
     (->> (eachDayOfInterval
           #js {:start (startOfMonth month)
                :end (endOfMonth month)})
          (filter #(isOff %))
          (count)))))

(re-frame/reg-sub
 ::default-month-shift-hours
 (fn [_ [_ month]]
   (let [month (or month (js/Date.))]
     (->> (eachDayOfInterval
           #js {:start (startOfMonth month)
                :end (endOfMonth month)})
          (remove #(isOff %))
          (map #(* 1 7.5))
          (reduce +)))))

(re-frame/reg-sub
 ::shift-workdays-by-staff
 :<- [::shifts-by-staff-and-date]
 :<- [::shift-patterns-by-id]
 (fn [[shifts patterns-by-id] [_ month]]
   (->> shifts
        (map (fn [[staff-id staff-shifts]]
               {staff-id (->> (vals staff-shifts)
                              (filter #(= (getMonth (js/Date. (:date %))) (getMonth month)))
                              (map #(get {false 0 true 1} (not (:isDayOff (patterns-by-id (:patternId %))))))
                              (reduce +))}))
        (into {}))))

(re-frame/reg-sub
 ::shift-weekends-by-staff
 :<- [::shifts-by-staff-and-date]
 :<- [::shift-patterns-by-id]
 (fn [[shifts patterns-by-id] [_ month]]
   (->> shifts
        (map (fn [[staff-id staff-shifts]]
               {staff-id (->> (vals staff-shifts)
                              (filter #(= (getMonth (js/Date. (:date %))) (getMonth month)))
                              (map #(and
                                     (not (:isDayOff (patterns-by-id (:patternId %))))
                                     (isOff (js/Date. (:date %))) ))
                              (reduce +))}))
        (into {}))))

(re-frame/reg-sub
 ::shift-weekdays-by-staff
 :<- [::shifts-by-staff-and-date]
 :<- [::shift-patterns-by-id]
 (fn [[shifts patterns-by-id] [_ month]]
   (->> shifts
        (map (fn [[staff-id staff-shifts]]
               {staff-id (->> (vals staff-shifts)
                              (filter #(= (getMonth (js/Date. (:date %))) (getMonth month)))
                              (map #(and
                                     (not (:isDayOff (patterns-by-id (:patternId %))))
                                     (not (isOff (js/Date. (:date %))))))
                              (reduce +))}))
        (into {}))))

(re-frame/reg-sub
 ::all-event-tags
 :<- [::calendars]
 (fn [calendars]
   (->> calendars
        (map :eventTags)
        (flatten)
        (distinct-by :id))))

(re-frame/reg-sub
 ::event-tags-by-id
 :<- [::all-event-tags]
 (fn [event-tags]
   (index-by event-tags :id)))

(re-frame/reg-sub
 ::all-event-statuses
 :<- [::calendars]
 (fn [calendars]
   (->> calendars
        (map :eventStatuses)
        (flatten)
        (distinct-by :id))))

(re-frame/reg-sub
 ::event-status-by-id
 :<- [::all-event-statuses]
 (fn [event-statuses]
   (index-by event-statuses :id)))

(re-frame/reg-sub
 ::events
 (fn [db]
   (->> (get db :events)
        (map #(assoc %
                     :date (format (js/Date. (:start %)) "yyyy-MM-dd")
                     :start (js/Date. (:start %))
                     :end (js/Date. (:end %))
                     :startTime (format-time (js/Date. (:start %)))
                     :endTime (format-time (js/Date. (:end %))))))))

;; Create one event by day during the interval of the event
(re-frame/reg-sub
 ::each-day-of-events
 :<- [::events]
 (fn [events]
   (->> events
        (map (fn [event]
               (if (isSameDay (:start event) (:end event))
                 event
                 (map #(assoc event :date (format % "yyyy-MM-dd"))
                      (eachDayOfInterval #js {:start (:start event)
                                              :end (:end event)})))))
        (flatten))))

(re-frame/reg-sub
 ::events-by-date
 :<- [::each-day-of-events]
 (fn [events]
   (group-by :date events)))

(re-frame/reg-sub
 ::submitted-events
 :<- [::events]
 (fn [events]
   (->> events
        (filter #(not= (:statusId %) "submitted")))))

(re-frame/reg-sub
 ::approved-events
 :<- [::events]
 (fn [events]
   (->> events
        (filter #(= (:statusId %) "approved")))))  ;; approved is a special status ID

(re-frame/reg-sub
 ::each-day-of-approved-events
 :<- [::approved-events]
 (fn [events]
   (->> events
        (map (fn [event]
               (if (isSameDay (:start event) (:end event))
                 event
                 (map #(assoc event :date (format % "yyyy-MM-dd"))
                      (eachDayOfInterval #js {:start (:start event)
                                              :end (:end event)})))))
        (flatten))))

(re-frame/reg-sub
 ::approved-events-by-date
 :<- [::each-day-of-approved-events]
 (fn [events]
   (group-by :date events)))

(re-frame/reg-sub
 ::locations
 (fn [db]
   (get db :locations)))

(re-frame/reg-sub
 ::locations-by-id
 (fn [db]
   (index-by (get db :locations) :id)))

(re-frame/reg-sub
 ::organizers
 (fn [db]
   (get db :organizers)))

(re-frame/reg-sub
 ::organizers-by-id
 (fn [db]
   (index-by (get db :organizers) :id)))
